import React, { Component } from "react";
import PropTypes from "prop-types";
import ThumbNail from "../../ThumbNail";
import styles from "./styles.less";
import cx from "classnames";

export class ResultBox extends Component {
  onClick = () => {
    const { result, onClick } = this.props;
    onClick(result.id);
  };

  renderMobileThumbnail = () => {
    const {
      innerRef,
      result,
      isRtl,
      isMobileView,
      titles,
      onShowDetailsClick,
      onClick,
      isRegionResult,
      isDeals,
      renderMarkup,
      renderImageMarkup,
      onImageLoad,
      isIos
    } = this.props;
    return (
      <div
        ref={innerRef}
        key={result && result.id}
        className={cx(styles.resultBoxWrapper, {
          [styles.resultBoxWrapperDeals]: isDeals && !isMobileView,
          [styles.resultBoxWrapperDealsMobile]: isDeals && isMobileView
        })}
      >
        <div className={styles.resultBoxThumbnailWrapper}>
          <ThumbNail
            onImageLoad={onImageLoad}
            product={result}
            isRtl={isRtl}
            isMobileView={isMobileView}
            titles={titles}
            extendedType={isRegionResult}
            onMoreDetailsClick={onShowDetailsClick}
            onClick={onClick}
            isDeals={isDeals}
            renderMarkup={renderMarkup}
            renderImageMarkup={renderImageMarkup}
            isIos={isIos}
          />
        </div>
        {/* <div
            className={styles.rateSelectBtn}
            onClick={this.onClick}
            onKeyDown={this.onClick}
            role="button"
            tabIndex="0"
          >
            {titles.Continue}
          </div> */}
      </div>
    );
  };

  render() {
    const {
      innerRef,
      result,
      isRtl,
      isMobileView,
      titles,
      onShowDetailsClick,
      onClick,
      isRegionResult,
      isDeals,
      renderMarkup,
      renderImageMarkup,
      onImageLoad,
      isIos
    } = this.props;
    return (
      <div
        ref={innerRef}
        key={result && result.id}
        className={cx(styles.resultBoxWrapper, {
          [styles.resultBoxWrapperDeals]: isDeals && !isMobileView,
          [styles.resultBoxWrapperDealsMobile]: isDeals && isMobileView
        })}
      >
        <div className={styles.resultBoxThumbnailWrapper}>
          <ThumbNail
            onImageLoad={onImageLoad}
            product={result}
            isRtl={isRtl}
            isMobileView={isMobileView}
            titles={titles}
            extendedType={isRegionResult}
            onMoreDetailsClick={onShowDetailsClick}
            onClick={onClick}
            isDeals={isDeals}
            renderMarkup={renderMarkup}
            renderImageMarkup={renderImageMarkup}
            isIos={isIos}
          />
        </div>
        {/* <div
            className={styles.rateSelectBtn}
            onClick={this.onClick}
            onKeyDown={this.onClick}
            role="button"
            tabIndex="0"
          >
            {titles.Continue}
          </div> */}
      </div>
    );
  }
}

ResultBox.defaultProps = {
  isRtl: false,
  titles: {},
  isRegionResult: false,
  isMobileView: false,
  result: {},
  onClick: () => {},
  onShowDetailsClick: () => {},
  innerRef: () => {},
  onImageLoad: () => {}
};

ResultBox.propTypes = {
  isRtl: PropTypes.bool,
  isRegionResult: PropTypes.bool,
  isMobileView: PropTypes.bool,
  titles: PropTypes.object,
  result: PropTypes.object,
  onClick: PropTypes.func,
  onShowDetailsClick: PropTypes.func,
  isDeals: PropTypes.bool,
  renderMarkup: PropTypes.func,
  renderImageMarkup: PropTypes.func,
  innerRef: PropTypes.func,
  onImageLoad: PropTypes.func,
  isIos: PropTypes.bool
};

export default ResultBox;



// WEBPACK FOOTER //
// ./src/components/ResultsGroup/ResultBox/ResultBox.js